import React from 'react';
import { useModal } from '../../../context/ModalContext';
import { CadastroClienteModal } from './CadastroClienteModal';
import { CadastroParceiroModal } from './CadastroParceiroModal';
import { ContatoModal } from './ContatoModal';
import { ContratarModal } from './ContratarModal';
import { LoginModal } from './LoginModal';
import { PartnerDetailModal } from './PartnerDetailModal';

export function ModalRoot() {
  const { modal } = useModal();

  if (!modal) return null;

  switch (modal) {
    case 'login':
      return <LoginModal />;
    case 'cadastroCliente':
      return <CadastroClienteModal />;
    case 'cadastroParceiro':
      return <CadastroParceiroModal />;
    case 'contato':
      return <ContatoModal />;
    case 'contratar':
      return <ContratarModal />;
    case 'partnerDetail':
      return <PartnerDetailModal />;
    default:
      return null;
  }
}
